/**
 * Detect how a media URL should be loaded.
 *
 * - `.m3u8` → HLS manifest, delegated to hls.js (or native on Safari)
 * - everything else → native <video src="…"> (mp4, webm, ogg, mov, …)
 *
 * Query strings and fragments are ignored when matching the extension.
 */
export type MediaSourceKind = 'hls' | 'native'

export function detectSourceKind(url: string): MediaSourceKind {
  return /\.m3u8(?:$|[?#])/i.test(url) ? 'hls' : 'native'
}
